import "./polyfills";
import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/pages/Home';
import Now from './components/pages/Now';
import useAuth from './hooks/useAuth'; // Adjust the import path according to your project structure
import Loading from "./components/common/Loading";
import TwoFA from "./components/pages/TwoFA";

function AuthWrapper() {
    const { user, tags, daysToShowOnMobile, lid, type, loading, general, lang} = useAuth();
    
    if (loading || tags.length === 0) {
        return <Loading/>;
    }
    
    return (
        <div className="container">
                <Suspense fallback={<Loading />}>
                    <Routes>
                        <Route
                            exact
                            path="/"
                            element={<Home tags={tags} lid={lid} type={type} user={user} daysToShowOnMobile={daysToShowOnMobile} general={general} lang={lang} />}
                        />
                        <Route exact path="/now" element={<Now lid={lid} type={type} user={user}  general={general} lang={lang} />} />
    
                        <Route exact path="/2fa"
                               element={<TwoFA lid={lid}/>}/>
                    </Routes>
                </Suspense>
        </div>
    );
}

function App() {
    return (
        <Router future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
        }}>
            <AuthWrapper />
        </Router>
    );
}

export default App;
